// ==============================
// 파일명 : src/constants/users/defaults.js
// 역할 : 사용자 관련 모듈에서 함께 사용하는 기본 설정 값을 한곳에서 정의하여
//         비밀번호 등 공통 상수를 일관되게 재사용할 수 있게 하는 모듈
// 수정일 : 2025-10-14
// ==============================

export const DEFAULT_USER_TEMP_PASSWORD = "Temp1234!"; // [수정-2025-10-14] Firebase 최소 길이·복잡도를 충족하는 임시 비밀번호 상수